module.exports = __webpack_public_path__ + "img/motor-dark.49366358.png";